import Card from "components/card";
import Loader from "components/loader";
import { getInstituciones } from "services/Reports";
import { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { routesNames } from "utils/Constants";

const TOP_N = 10;

const columns = [
  {
    title: "Institución",
    dataIndex: "nombre",
    render: (text, record) => (
      <Link to={`${routesNames.USER}/${record.user_id}`} className="text-sm font-semibold text-blue-800 dark:text-white">
        {text}
      </Link>
    ),
  },
  {
    title: "Publicaciones",
    dataIndex: "publicaciones_count",
  },
  {
    title: "Postulaciones",
    dataIndex: "postulaciones_count",
  },
  {
    title: "Promedio/pub",
    dataIndex: "promedio",
  },
];

const TopInstitutionsByApplicationsTable = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [instituciones, setInstituciones] = useState([]);

  const fetchInstituciones = async () => {
    setIsLoading(true);
    const data = await getInstituciones();
    const rows = Array.isArray(data?.[0]) ? data[0] : [];

    const top = [...rows]
      .sort((a, b) => Number(b?.postulaciones_count || 0) - Number(a?.postulaciones_count || 0))
      .slice(0, TOP_N)
      .map((item) => {
        const publicaciones = Number(item?.publicaciones_count || 0);
        const postulaciones = Number(item?.postulaciones_count || 0);
        return {
          ...item,
          promedio: publicaciones > 0 ? Math.round((postulaciones / publicaciones) * 10) / 10 : 0,
        };
      });

    setInstituciones(top);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchInstituciones();
  }, []);

  return (
    <Card extra="w-full h-full px-6 py-4">
      <div className="text-xl font-bold text-navy-700 dark:text-white mb-2">
        Top instituciones por postulaciones recibidas
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <Table
          columns={columns}
          dataSource={instituciones}
          rowKey={(record) => record.user_id}
          size="small"
          pagination={false}
          locale={{ emptyText: "No hay datos disponibles" }}
        />
      )}
    </Card>
  );
};

export default TopInstitutionsByApplicationsTable;
